import React from "react";

const Svg = ({}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <rect x="0.5" y="1" width="19" height="19" rx="9.5" fill="white" />
      <rect x="0.5" y="1" width="19" height="19" rx="9.5" stroke="#BEBEBE" />
      <path
        d="M12.6589 7.84058L7.33984 13.1596M7.33984 7.84058L12.6589 13.1596"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Svg;
